import React from 'react';
import TwoColumnTextImageDesktop from './twoColumnTextImageDesktop/twoColumnTextImageDesktop';
import TwoColumnTextImageMobile from './twoColumnTextImageMobile/twoColumnTextImageMobile';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import styles from './twoColumnTextImage.module.scss';

function TwoColumnTextImage(props) {
  const { width } = useWindowDimensions();
  return (
    <div className={styles.container}>
      {width < 768 && <TwoColumnTextImageMobile {...props} />}
      {width >= 768 && <TwoColumnTextImageDesktop {...props} />}
    </div>
  );
}
export default TwoColumnTextImage;
